import type { DataTableColumn as GridColDef } from '@/components/custom/erp';
import { formatDate, formatMoney, roundNumber } from '@/lib/formatUtils';
import { DETAIL_BY_OPTIONS } from './constant';

export const invoiceReportColumns = (detail_by?: number): GridColDef[] => [
  {
    field: 'ma',
    headerName: `Mã ${DETAIL_BY_OPTIONS.find(option => option.value === detail_by)?.label}`,
    width: 140,
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  },
  {
    field: 'ten',
    headerName: `Tên ${DETAIL_BY_OPTIONS.find(option => option.value === detail_by)?.label}`,
    width: 250,
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  },
  {
    field: 'sl_xuat',
    headerName: 'Số lượng',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(roundNumber(params.value)),
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  },
  {
    field: 'gia2',
    headerName: 'Giá bán',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(roundNumber(params.value)),
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  },
  {
    field: 'tien2',
    headerName: 'Doanh số',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(roundNumber(params.value)),
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  },
  {
    field: 'thue',
    headerName: 'Thuế',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(roundNumber(params.value)),
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  },
  {
    field: 'ck',
    headerName: 'Chiết khấu',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(roundNumber(params.value)),
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  },
  {
    field: 'tien_tl',
    headerName: 'Trả lại',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(roundNumber(params.value)),
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  },
  {
    field: 'pt',
    headerName: 'Phải thu',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(roundNumber(params.value)),
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  },
  {
    field: 'gia',
    headerName: 'Giá vốn',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(roundNumber(params.value)),
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  },
  {
    field: 'tien_von',
    headerName: 'Tiền vốn',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(roundNumber(params.value)),
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  },
  {
    field: 'lai',
    headerName: 'Lãi',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(roundNumber(params.value)),
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  },
  {
    field: 'tl_gv_gb',
    headerName: '% GV/GB',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(roundNumber(params.value)),
    cellClassName: params => (params.row.is_group ? 'font-bold' : '')
  }
];
